export default __webpack_public_path__ + "static/pinterest_icon-5f3dd0db6c22e211c3a4912a5d9d54d6.png";